import {
  Form,
  SubmitButton,
  TextAreaInputField,
  TextInputField,
} from '@/components';
import { SubProjectFundInfoFormSchema } from '@/features/project/projects/_models/sub-project';
import { useForm } from '@/hooks';
import { zodResolver } from '@hookform/resolvers/zod';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';

type FormValues = z.infer<typeof SubProjectFundInfoFormSchema>;

type Props = {
  initialValues?: Partial<FormValues>;
  onSubmit: (values: FormValues) => void;
};

export const SubProjectFundInfoForm: FC<Props> = ({
  initialValues,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting, isDirty, isSubmitSuccessful },
  } = useForm<FormValues>({
    defaultValues: initialValues,
    resolver: zodResolver(SubProjectFundInfoFormSchema),
  });

  return (
    <Form
      leavePageAlertCondition={{
        isDirty,
        isSubmitting,
        isSubmitSuccessful,
      }}
      layout="vertical"
      onFinish={handleSubmit(onSubmit)}
    >
      <TextInputField
        control={control}
        name="localFundOwner"
        errors={errors}
        label={t('fund-owner-for-local-government')}
        required
      />
      <TextAreaInputField
        control={control}
        name="name"
        errors={errors}
        label={t('fund-name')}
        required
      />
      <TextAreaInputField
        control={control}
        name="localFundOverview"
        errors={errors}
        label={t('fund-overview-for-local-government')}
        required
      />
      <SubmitButton disabled={!isDirty} loading={isSubmitting} />
    </Form>
  );
};
